import { createSlice } from "@reduxjs/toolkit"
import { STATUSES, DEFAULT_STATE_VALUE,WindowState } from "Utils/constants";

// create slice
const errorInfo = createSlice({
  name: "errorInfo",
  initialState: {
    status: STATUSES.NORMAL,
    popup: {
      visible: false,
      title: "",
      msg: "",
      showContactHelp: false
    },
    redirect: {
      redirect: false, 
      redirectFirst: false,
      path: "",
      data:{}
    }
  },
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload
    },
    setPopup: (state, action) => {
      state.popup = action.payload
    },
    setRedirect: (state, action) => {
      state.redirect = action.payload
    }
  }
})

/*const { actions, reducer } = errorInfo
export const { setStatus, setPopup, setRedirect } = actions;
export default reducer;*/

//const { actions, reducer } = errorInfo
//export const { setStatus, setPopup, setRedirect } = actions;
//export default reducer;

export const { setStatus, setPopup, setRedirect } = errorInfo.actions
export default errorInfo.reducer

// action: {type: name/functionName}
//export const { setData, setLoading, setError } = errorInfo.actions
//export default errorInfo.reducer